import socket from '@/services/socket'

const ModuleSocket = {
  state: () => ({
    handlers: {} // { eventName: function }
  }),

  mutations: {
    REGISTER_HANDLER (state, { event, handler }) {
      state.handlers[event] = handler
    },
    REMOVE_HANDLER (state, event) {
      delete state.handlers[event]
    }
  },

  actions: {
    onSocket ({ state, commit }, { event, handler }) {
      if (state.handlers[event]) return // ❗ กัน on ซ้ำ

      socket.on(event, handler)
      commit('REGISTER_HANDLER', { event, handler })
    },
    offSocket ({ state, commit }, event) {
      const handler = state.handlers[event]
      if (!handler) return

      socket.off(event, handler)
      commit('REMOVE_HANDLER', event)
    }
  }
}
export default ModuleSocket
